import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { createSelectPartnerProperty } from '../helpers/createSelectPartnerProperty'

export const useGetPartnerProperty = <T>(fieldName: string) => {
  const selectPartnerProperty = useMemo(() => createSelectPartnerProperty(fieldName), [fieldName])

  const value = useSelector(selectPartnerProperty)

  return value as T
}
